<template>
  <div class="xcard">
    <v-btn small class="mx-0" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <div class="ml-2">
        <p class="mb-0"><b>Sucursal:</b> {{ xnumsucursal }}</p>
        <p class="mb-0"><b>P. Venta:</b> {{ xpventa }}</p>
      </div>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Eventos Contingencia del Punto de venta </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-select
              v-model="filtro"
              :items="filtros"
              :disabled="loading"
              return-object
              filled
              label="Filtrar"
              class="mt-6"
              dense
            />
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1" color="orange" small v-bind="attrs" v-on="on" @click="verItem(item)">
                mdi-eye
              </v-icon>
            </template>
            <span> Ver detalles </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1" color="purple" small v-bind="attrs" v-on="on" @click="verItemFacturas(item)">
                mdi-clipboard-outline
              </v-icon>
            </template>
            <span> Ver Facturas </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="item.codigoRecepcion == null"
                color="green"
                small
                v-bind="attrs"
                v-on="on"
                @click="recepcionItem(item)"
              >
                mdi-clipboard-text-multiple-outline
              </v-icon>
            </template>
            <span> Emision por paquete </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="item.codigoRecepcion == null"
                class="mr-1"
                color="green"
                small
                v-bind="attrs"
                v-on="on"
                @click="verEnvios(item)"
              >
                mdi-check-decagram
              </v-icon>
            </template>
            <span> Ver envios </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="item.codigoRecepcion != null"
                class="red--text"
                small
                v-bind="attrs"
                v-on="on"
                @click="finalizarItem(item)"
              >
                mdi-bomb
              </v-icon>
            </template>
            <span> Finalizar Evento </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>

    <EventosReg ref="eventosreg" v-on:newregevento="newregevento" />
    <EventosView ref="eventoview" />
    <EventoFin ref="eventofin" v-on:eventoFinalizado="eventoFinalizado" />
    <EventosRecep ref="eventosrecep" v-on:newregevento="newregevento" />
    <EventosViewf ref="eventosviewf" />
  </div>
</template>

<script>
  import EventosReg from '@/views/recibos/esignificativos/registrar.vue';
  import EventosView from '@/views/recibos/esignificativos/eventoview.vue';
  import EventoFin from '@/views/recibos/esignificativos/finalizar.vue';
  import EventosViewf from '@/views/recibos/esignificativos/eventoviewfacturas.vue';
  import EventosRecep from '@/views/recibos/emisionpaq/recepcionpaquete.vue';
  import { getAccessToken } from '@/accessToken';
  import xaxios from '@/xaxios';
  import axios from 'axios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      // headers: [
      //   { text: 'Nombre', value: 'nombre' },
      //   { text: 'Municipio', value: 'municipio' },
      //   { text: 'Telefono', value: 'telefono' },
      //   { text: 'Direccion', value: 'direccion' },
      //   { text: 'Codigo Sucursal', value: 'codigoSucursal' },
      //   { text: 'Opciones', value: 'opciones', sortable: false },
      // ],
      filtros: [
        { id: 1, text: 'Todos' },
        { id: 2, text: 'Finalizados' },
        { id: 3, text: 'No Finalizados' },
      ],
      filtro: null,
      headers: [
        { text: 'Codigo', value: 'codigo' },
        { text: 'Descripcion', value: 'descripcion' },
        { text: 'Codigo Recepcion', value: 'codigoRecepcion' },
        { text: 'Punto Venta', value: 'puntoVenta.codigoPuntoVenta' },
        { text: 'Codigo Recp.', value: 'codigoRecepcion' },
        //{ text: 'Cufd Id', value: 'cufdId' },
        //{ text: 'Cufd Evento', value: 'cufdEvento' },
        { text: 'Fecha inicio', value: 'fecha_inicio' },
        { text: 'Fecha fin', value: 'fecha_fin' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: 140 },
      ],
      dessertscopy: [],
      desserts: [],
      editedIndex: -1,
      xnumsucursal: null,
      xpventa: null,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      apikeytoken: null,
    }),

    components: { EventosReg, EventosView, EventoFin, EventosViewf, EventosRecep },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
      filtro: function() {
        if (!this.filtro) return;
        window.console.log(this.filtro);
        this.desserts = [];
        let vue = this;
        if (this.filtro.id == 1) {
          this.dessertscopy.forEach((x) => {
            vue.desserts.push(x);
          });
        } else if (this.filtro.id == 2) {
          this.dessertscopy.forEach((x) => {
            if (x.codigoRecepcion) vue.desserts.push(x);
          });
        } else if (this.filtro.id == 3) {
          this.dessertscopy.forEach((x) => {
            if (!x.codigoRecepcion) vue.desserts.push(x);
          });
        }
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      async initialize() {
        let vue = this;
        vue.loading = true;
        this.desserts = [];
        this.dessertscopy = [];
        let numsucursal = this.$route.query.numsucursal;
        let codigopunto = this.$route.query.codigopunto;
        this.xnumsucursal = numsucursal;
        this.xpventa = codigopunto;
        await this.obtenerToknFactura();

        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventosignificativo/sucursal/${numsucursal}/puntoventa/${codigopunto}`,
          headers: {
            apikey: this.apikeytoken,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.reverse();
            window.console.log('eventos:', data);
            data.forEach((x) => {
              vue.dessertscopy.push(x);
            });
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      newregevento(item) {
        let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.codigo = item.codigo;
          e.codigoPuntoVenta = item.codigoPuntoVenta;
          e.numero_documento = item.numero_documento;
          e.codigoSucursal = item.codigoSucursal;
          e.descripcion = item.descripcion;
        } else {
          this.initialize();
        }
      },

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        let numsucursal = parseInt(this.$route.query.numsucursal);
        let codigopunto = parseInt(this.$route.query.codigopunto);
        let data = {
          codigoSucursal: numsucursal,
          codigoPuntoVenta: codigopunto,
        };
        this.$refs.eventosreg.openmodal(null, data);
      },

      verItem(item) {
        this.$refs.eventoview.openmodal(item);
      },

      recepcionItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        this.$refs.eventosrecep.openmodal(item);
      },
      verEnvios(item) {
        this.$router.push('/eventossigenvios?ideventosig=' + item.id);
      },
      verItemFacturas(item) {
        this.$refs.eventosviewf.openmodal(item);
      },

      finalizarItem(item) {
        this.$refs.eventofin.openmodal(item);
      },

      eventoFinalizado() {
        this.initialize();
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialogDelete = true;
        this.$refs.unidadesdel.openmodal();
      },

      deleteItemConfirm() {
        this.desserts.splice(this.editedIndex, 1);
        this.closeDelete();
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      async obtenerToknFactura() {
        let idsuc = this.$route.query.idsucursal;
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));
      },
    },
  };
</script>
